import React, { useEffect, useState } from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import { FaRegCalendarAlt, FaEye } from "react-icons/fa";
import { Blog } from './BlogData';
import { Link } from 'react-router-dom';
import { truncateText } from './truncateText';
import { LuArrowRightCircle } from "react-icons/lu";
import { CiCalendar } from 'react-icons/ci';
import { FiClock } from 'react-icons/fi';
import axios from 'axios';
import BlogDetails from './BlogDetails';

interface BlogListProps {
    blogs: Blog[];
    count: number;
}

interface NewsStructure {
  id:string;
  title:string;
  img:string;
  desc:string;
  date:string;
}

const BlogList: React.FC<BlogListProps> = ({ blogs,count }) =>{
  const api = process.env.REACT_APP_API_URL as string;
  const[cnumber,setCnumber] = useState(1);
  const [newData, setNewData] = useState<NewsStructure[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(
          `${api}/auth/news`
        );

        // //console.log('news data',response.data)
        setNewData(response.data);
        // //console.log("news data in a array",newData);
      } catch (error) {
        // console.error("Post Not Found:", error);
      }
    };

    fetchData();
  }, []);
  
  return (
    <div className='bg-tabbg py-8'>
        <div className="flex flex-wrap gap-y-5 w-[100%] justify-between mt-10">

        {newData.slice(0, count).map((data, index) => {
  // Format the date
  const formattedDate = new Date(data.date).toLocaleDateString('en-US', {
    timeZone: 'Asia/Kolkata', // Your desired time zone
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return (
    <div
  key={index}
  className="bg-[#344056] border z-30 border-[#64748B] rounded-2xl p-5 relative sm:w-full md:w-[49%] lg:w-[32%]"
>
  <button className="bg-[#FDBC12] text-[#101729] font-[13px] rounded-tr-[16px] absolute top-[20px] right-[20px] py-2 px-3">
    News
  </button>
  <img
    className="rounded-t-2xl w-full object-cover  sm:h-[490px] md:h-[370px] lg:h-[370px]"
    src={`${api}/${data.img}`}
    alt={data.title}
  />
  <div className="flex flex-wrap justify-between my-5">
    <div className="flex items-center w-full lg:w-[60%]">
      <CiCalendar className="text-[#94A2B8]" />
      <span className="text-[#94A2B8] font-[13px] ml-1">{formattedDate}</span>
    </div>
    <div className="flex items-center w-full lg:w-[40%] lg:justify-end">
      <FiClock className="text-[#94A2B8]" />
      <span className="text-[#94A2B8] font-[13px] ml-1">5 Minutes Read</span>
    </div>
  </div>
  <span className="text-wrap break-words lg:text-[22px] md:text-[18px] font-semibold text-[#F5F5F5]">
    {data.title}
  </span>
  <button
    className="w-full bg-[#465468] py-3 border border-[#64748B] rounded-lg text-[#D7D3D2] text-[16px] mt-4 hover:bg-[#FDBC12] hover:text-[#101729] hover:border-[#FDBC12]"
    onClick={() => {
      window.location.href = `/blog/${data.title}`;
    }}
  >
    Read More
  </button>
</div>

  );
})}

          
        </div>
    </div>
);
};

export default BlogList;
